import React from 'react'
import styles from './AccountSelectionModal.module.scss'
import {Cancel} from '../../assets/svgs'

interface AccountSelectionModalProps {
  accounts: Array<{id: string; name: string}>
  onSelect: (accountId: string) => void
  onClose: () => void
}

const AccountSelectionModal: React.FC<AccountSelectionModalProps> = ({
  accounts,
  onSelect,
  onClose
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.cancelContainer}>
        <Cancel className={styles.cancel} onClick={onClose} />
      </div>
      <div className={styles.content}>
        <div className={styles.modalContent}>
          <div className={styles.headingContainer}>
            Select Account
          </div>
          <p className={styles.subText}>
            Please select an account to proceed.
          </p>
          <div className={styles.accountsList}>
            {accounts.map((account) => (
              <div
                key={account.id}
                className={styles.accountItem}
                onClick={() => onSelect(account.id)}
              >
                {account.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountSelectionModal